import {
  Anchor,
  Group,
  Paper,
  Stack,
  Text,
  Title,
  UnstyledButton,
} from '@mantine/core';
import { IconCheck, IconCircleDashed, IconRocket } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useOnboardingProgress } from '../hooks/useOnboardingProgress';

export function OnboardingChecklist() {
  const navigate = useNavigate();
  const { items, completedCount, total, allDone, dismissed, dismiss } =
    useOnboardingProgress();

  const childItem = items.find((i) => i.key === 'child');
  if (dismissed || allDone || !childItem?.done) {
    return null;
  }

  return (
    <Paper p="lg" radius="md" withBorder>
      <Stack gap="sm">
        <Group justify="space-between" align="flex-start">
          <Group gap="xs">
            <IconRocket size={22} />
            <Title order={4}>Get Started</Title>
          </Group>
          <Anchor
            component="button"
            type="button"
            size="xs"
            c="dimmed"
            onClick={dismiss}
          >
            Dismiss
          </Anchor>
        </Group>

        <Stack gap={4}>
          {items.map((item) => {
            const inactive = item.done || !item.href;
            return (
              <UnstyledButton
                key={item.key}
                w="100%"
                px="sm"
                py="xs"
                disabled={inactive}
                onClick={() => {
                  if (item.href) navigate(item.href);
                }}
                styles={{
                  root: {
                    borderRadius: 'var(--mantine-radius-sm)',
                    cursor: inactive ? 'default' : 'pointer',
                    opacity: item.done ? 0.6 : 1,
                    '&:hover': {
                      backgroundColor: inactive
                        ? 'transparent'
                        : 'var(--mantine-color-gray-1)',
                    },
                  },
                }}
              >
                <Group gap="sm" wrap="nowrap">
                  {item.done ? (
                    <IconCheck size={20} color="var(--mantine-color-teal-6)" />
                  ) : (
                    <IconCircleDashed
                      size={20}
                      color="var(--mantine-color-gray-5)"
                    />
                  )}
                  <Text
                    size="sm"
                    td={item.done ? 'line-through' : undefined}
                    c={item.done ? 'dimmed' : undefined}
                  >
                    {item.label}
                  </Text>
                </Group>
              </UnstyledButton>
            );
          })}
        </Stack>

        <Text size="xs" c="dimmed">
          {completedCount} of {total} done
        </Text>
      </Stack>
    </Paper>
  );
}
